/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import { Button, CircularProgress } from "@mui/material";
import { GridRowId } from "@mui/x-data-grid";
import React from "react";

interface IAddProps {
    isLoading: boolean;
    id: string | number;
    disabled: boolean;
    addHandler: (id: GridRowId) => void;
}

const AddButton: React.FC<IAddProps> = ({
    isLoading,
    id,
    disabled = false,
    addHandler,
}) => {
    return (
        <Button
            size="medium"
            variant="contained"
            color="primary"
            sx={{ float: "inline-end" }}
            startIcon={
                isLoading ? <CircularProgress size={20} color="inherit" /> : null
            }
            onClick={() => addHandler(id)}
            disabled={isLoading || disabled}
        >
            Add
        </Button>
    );
};

export default AddButton;